


























































































































































































































































import SettingApi from "@/api/settingApi";

import { Component, Vue, Watch } from "vue-property-decorator";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import Setting from "@/model/setting";
import { Category } from "@/model/product";
import categoryApi from "@/api/categoryApi";
import draggable from "vuedraggable";
import QCalendar from "@/common/qCalendar.vue";
import {compareWithKeys} from "@/common/utils";

@Component({
  name: "SettingComponent",
  components: {
    QErrors,
    draggable,
    QCalendar,
  },
})
export default class SettingComponent extends Vue {
  public dateConfig = {
    disableMobile: "true",
    minDate: new Date(),
    dateFormat: "Y-m-d H:i",
    enableTime: true,
    defaultHour: 0,
    defaultMinute: 0,
    allowInput: false,
  };
  oldSetting: any = null;
  public categories: Category[] = [];
  public categoriesInit: Category[] = [];
  public setting: Setting[] = [
    new Setting({
      id: 0,
      name: "",
      value: "",
      description: "",
    }),
  ];
  public calendarPeriod = "";
  public freeShipping = "";
  public orderDeadlineHour = "";
  public orderDeadlineMinute = "";
  public newsInit = "";
  public news = "";
  public maintenanceInit:any = {};
  public maintenance = {
    startTime: null,
    endTime: null,
    message: null,
  };
  public errors = [];
  public allowedStoreFields = ["calendar_period", "free_shipping", "order_deadline_hour", "order_deadline_minute"];

  async mounted() {
    await SettingApi.view().then((response) => {
      this.setting = response.data.data ? response.data.data : [this.setting];
    });
    this.oldSetting = JSON.parse(JSON.stringify(this.setting));
    this.calendarPeriod = await this.getSettingValue("calendar_period");
    this.freeShipping = await this.getSettingValue("free_shipping");
    this.orderDeadlineHour = await this.getSettingValue("order_deadline_hour");
    this.orderDeadlineMinute = await this.getSettingValue(
      "order_deadline_minute"
    );
    this.news = await this.getSettingValue(
      "news"
    );
    this.maintenance = {
      startTime: await this.getSettingValue("maintenance_start_time"),
      endTime: await this.getSettingValue("maintenance_end_time"),
      message: await this.getSettingValue("maintenance_message"),
    };
    this.categories = await categoryApi.getCategory();
    this.newsInit = this.news;
    this.maintenanceInit = { ...this.maintenance };
  }

  public async getSettingValue(parameter, isReset = false) {
    let result = "";
    if (isReset) {
      this.oldSetting.filter(function (item) {
        if (item.name == parameter) {
          result = item.value;
        }
      });
    } else {
      this.setting.filter(function (item) {
        if (item.name == parameter) {
          result = item.value;
        }
      });
    }

    return result;
  }

  async submitNews(): Promise<void> {
    try {
      await SettingApi.updateNews({
        news: this.news,
      }).then((response) => {
        if (response.data.meta.status == 200) {
          this.clearError('news');
          this.newsInit = this.news;
          QNotify.success({
            text: response.data.meta.message,
          });
        } else {
          QNotify.error({
            text: response.data.meta.message,
          });
          this.errors = {
            ...this.errors,
            ...response.data.meta.errors
          };
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  public async cancelNews() {
    if (this.newsInit !== this.news) {
      this.$modal.showCancel({
        text: `${this.$t("common.cancel_message", {
          name: 'お知らせ内容',
        })}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        confirmClass: "mb__add-color-blue",

        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.news = this.newsInit;
        },
      });
    }
  }

  async submitMaintenance(): Promise<void> {
    try {
      await SettingApi.updateMaintenance({
        maintenance_start_time: this.maintenance.startTime,
        maintenance_end_time: this.maintenance.endTime,
        maintenance_message: this.maintenance.message,
      }).then((response) => {
        if (response.data.meta.status == 200) {
          this.maintenanceInit = { ...this.maintenance };
          this.clearError('maintenance_start_time');
          this.clearError('maintenance_end_time');
          this.clearError('maintenance_message');
          QNotify.success({
            text: response.data.meta.message,
          });
        } else {
          QNotify.error({
            text: response.data.meta.message,
          });
          this.errors = {
            ...this.errors,
            ...response.data.meta.errors
          };
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  public cancelMaintenance() {
    if (compareWithKeys(this.maintenanceInit, this.maintenance, [
      "startTime",
      "endTime",
      "message",
    ])) {
      this.$modal.showCancel({
        text: `${this.$t("common.cancel_message", {
          name: 'メンテナンス設定',
        })}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        confirmClass: "mb__add-color-blue",

        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.maintenance = { ...this.maintenanceInit }
        },
      });
    }
  }

  public async confirmCancel() {
    this.setting = this.oldSetting;
    this.calendarPeriod = await this.getSettingValue("calendar_period", true);
    this.freeShipping = await this.getSettingValue("free_shipping", true);
    this.orderDeadlineHour = await this.getSettingValue(
      "order_deadline_hour",
      true
    );
    this.orderDeadlineMinute = await this.getSettingValue(
      "order_deadline_minute",
      true
    );
    this.errors = [];
  }

  async submit(): Promise<void> {
    this.errors = [];
    
    let setting = await this.prepareSettingSubmit();
    try {
      await SettingApi.store({
        settings: setting,
      }).then((response) => {
        if (response.data.meta.status == 200) {
          QNotify.success({
            text: response.data.meta.message,
          });
        } else {
          QNotify.error({
            text: response.data.meta.message,
          });
          this.errors = response.data.meta.errors;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  addSetting(index, name, value) {
    this.setting.splice(index, 0, new Setting({
      id: 0,
      name,
      value,
      description: "",
    }));
  }

  prepareSettingSubmit() {
    const missingFields = this.allowedStoreFields.filter(fieldName => {
      return !this.setting.some(item => item.name === fieldName);
    });
    for (const fieldName of missingFields) {
      switch (fieldName) {
      case "calendar_period":
        this.addSetting(0, "calendar_period", this.calendarPeriod);
        break;
      case "free_shipping":
        this.addSetting(1, "free_shipping", this.freeShipping);
        break;
      case "order_deadline_hour":
        this.addSetting(2, "order_deadline_hour", this.orderDeadlineHour);
        break;
      case "order_deadline_minute":
        this.addSetting(3, "order_deadline_minute", this.orderDeadlineMinute);
        break;
      }
    }
    return this.setting.filter((item) => {
      if (this.allowedStoreFields.includes(item.name)) {
        switch (item.name) {
        case "calendar_period":
          item.value = this.calendarPeriod;
          break;
        case "free_shipping":
          item.value = this.freeShipping;
          break;
        case "order_deadline_hour":
          item.value = this.orderDeadlineHour;
          break;
        case "order_deadline_minute":
          item.value = this.orderDeadlineMinute;
          break;
        }
        return true;
      } else {
        return false;
      }
    });
  }

  getMinutes() {
    let result = [];
    for (let index = 0; index < 6; index++) {
      if (index === 0) {
        result.push("00", "05");
      } else {
        result.push((index * 10).toString(), (index * 10 + 5).toString());
      }
    }

    return result;
  }

  getHours() {
    let result = [];
    for (let index = 0; index < 24; index++) {
      result.push(index);
    }

    return result;
  }

  async submitCategories() {
    this.errors = [];
    this.categories.filter((item, key) => (item.category_sort = key + 1));

    try {
      await SettingApi.storeCategories({
        categories: this.categories,
      }).then((response) => {
        if (response.data.meta.status == 200) {
          QNotify.success({
            text: response.data.meta.message,
          });
        } else {
          QNotify.error({
            text: response.data.meta.message,
          });
          this.errors = response.data.meta.errors;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  async confirmCategoryCancel() {
    this.errors = [];
    this.categories = JSON.parse(JSON.stringify(this.categoriesInit));
  }

  async remove(category_code, index) {
    this.errors = [];
    if (category_code) {
      let data = [];
      data[index] = { category_name: category_code };

      await SettingApi.checkIsDelete({
        categories: data,
      }).then((response) => {
        if (response.data.meta.status == 200) {
          this.categories.map((value, key) => {
            if (value.category_code === category_code) {
              this.categories.splice(key, 1);
            }
          });
        } else {
          QNotify.error({
            text: response.data.meta.message,
          });
          this.errors = response.data.meta.errors;
        }
      });
    } else {
      this.categories.map((value, key) => {
        if (value.category_code === category_code) {
          this.categories.splice(key, 1);
        }
      });
    }
  }

  async addNewCategory() {
    this.categories.push(
      new Category({
        category_name: "",
        category_code: this.makeRandomText(),
        category_sort: this.categories.length + 1,
      })
    );
  }

  @Watch('categories')
  watchCategories() {
    this.errors = [];
  }

  makeRandomText() {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    let index = 0;
    for (index; index < 7; index++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  clearError(key) {
    if (key in this.errors) {
      this.errors[key] = [];
    }
  }
}
